import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import MusicDashboard from '../../../layouts/musicDashboard';
import RightSide from "../../../components/rightSide/rightSide";
import { showLoading, hideLoading } from 'react-redux-loading-bar';
import { connect } from 'react-redux';
import Spinner from 'react-bootstrap/Spinner';

import * as spotifyActions from '../../../store/spotifyPlaylists/actions';

const SpotifyPlaylists = ({
    loggingIn,
    getSpotifyPlaylists,
    loadMoreSpotifyPlaylists,
    playlists,
    hasMore,
    userProfile
}) => {
    const navigate = useNavigate();
    const [page, setPage] = useState(1);
    const [processing, setProcessing] = useState(false);
    const [loadingMore, setLoadingMore] = useState(false);
    const pageLimit = userProfile?.express_view && userProfile.express_view === '1' ? 18 : 12;

    useEffect(() => {
        if (loggingIn !== undefined && loggingIn === false) {
            navigate('/sign-in');
        } else {
            loadData();
        }
    }, [userProfile]);

    const loadData = async () => {
        setProcessing(true);
        setPage(1);
        await getSpotifyPlaylists({ page: 1, limit: pageLimit });
        setProcessing(false);
        window.scrollTo({ top: 0 });
    };

    const handleLoadMore = async () => {
        const nextPage = page + 1;
        setLoadingMore(true);
        setPage(nextPage);
        await loadMoreSpotifyPlaylists({ page: nextPage, limit: pageLimit });
        setLoadingMore(false);
    };
    console.log('playlists', playlists)
    return (
        <MusicDashboard
            rightContent={
                userProfile?.express_view && userProfile.express_view === '1'
                    ? ''
                    : <RightSide blocks={{ top30TrendingTracks: true }} />
            }
            accountPages={userProfile?.express_view && userProfile.express_view === '1' ? true : false}
        >
            <div className="content-sec">
                <div className="play-list-sec">
                    <div className="top-heading">
                        <h2>Spotify Playlists</h2>
                    </div>
                    <div className="inner-block p-5">
                        {processing ? (
                            <div className="text-center py-5">
                                <Spinner />
                            </div>
                        ) : (
                            <div className="spotify-playlists-grid">
                                {playlists.map((playlist) => (
                                    <div key={playlist.id} className="spotify-playlist-embed">
                                        <iframe
                                            src={`https://open.spotify.com/embed/playlist/${playlist.id}`}
                                            width="100%"
                                            height="380"
                                            style={{ border: 'none' }}
                                            allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                                            loading="lazy"
                                            title={playlist.name}
                                        />
                                    </div>
                                ))}
                            </div>
                        )}
                    
                    {!processing && hasMore && (
                        <div className="load-more-btn text-center mt-4">
                            <span className="load-more cp primary-btn view-all-genres-btn" onClick={handleLoadMore}>
                                Load more &nbsp;{loadingMore ? <Spinner size="sm" /> : ''}
                            </span>
                        </div>
                    )}
                    </div>
                </div>
            </div>
        </MusicDashboard>
    );
};

function mapStateToProps(state) {
    return {
        loggingIn: state.authentication.loggedIn,
        playlists: state.spotify.spotifyPlaylistObject && state.spotify.spotifyPlaylistObject.items
            ? state.spotify.spotifyPlaylistObject.items
            : [],
        hasMore: state.spotify.spotifyPlaylistObject
            ? state.spotify.spotifyPlaylistObject.hasMore
            : false,
        userProfile: state.customer.customerProfile,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getSpotifyPlaylists: (post) => dispatch(spotifyActions.getSpotifyPlaylists(post)),
        loadMoreSpotifyPlaylists: (post) => dispatch(spotifyActions.loadMoreSpotifyPlaylists(post)),
        displayLoading: (sectionBar) => dispatch(showLoading(sectionBar)),
        hideLoading: (sectionBar) => dispatch(hideLoading(sectionBar)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SpotifyPlaylists);
